export default __webpack_public_path__ + "static/media/property_1_12.09791c4b.webp";